// extracted by mini-css-extract-plugin
export var heading = "index-module--heading--8b74f";
export var headingContainer = "index-module--heading-container--5d00f";
export var highlight = "index-module--highlight--cd7c6";
export var highlightLine = "index-module--highlight-line--3f5f6";
export var image1 = "index-module--image-1--faa1b";
export var image2 = "index-module--image-2--55384";
export var imageContainer = "index-module--image-container--4d94b";